/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getPreferences.defs.js'
export * as $defs from './getPreferences.defs.js'
